var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 40,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v(_vm._s(_vm.remarkDesc))]),
          ]
        ),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "slot-height" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _c("div", { staticClass: "columns is-gapless" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("Job No")]),
                    _c("span", { staticClass: "is-size-6" }, [
                      _vm._v(_vm._s(_vm.jobNo)),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "column", staticStyle: { height: "100%" } },
                    [
                      _c("div", { staticClass: "field pb-5" }, [
                        _c("div", { staticClass: "control is-pulled-right" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "button is-small is-success tooltip is-tooltip",
                              attrs: {
                                "data-tooltip": !_vm.isAddNote
                                  ? "Add new note"
                                  : "Close add new note",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleNote(_vm.isAddNote)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-18px",
                                  class: !_vm.isAddNote
                                    ? "mdi-plus"
                                    : "mdi-close",
                                }),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.isAddNote ? "Close Note" : "Add Note"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _c("expand-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddNote,
                          expression: "isAddNote",
                        },
                      ],
                    },
                    [
                      _c("div", { staticClass: "field pb-0" }, [
                        _c("div", { staticClass: "control" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newNote.remarks,
                                expression: "newNote.remarks",
                              },
                              {
                                name: "focus-inserted",
                                rawName: "v-focus-inserted",
                              },
                            ],
                            staticClass: "textarea",
                            class: {
                              "is-danger": _vm.$v.newNote.remarks.$error,
                            },
                            attrs: { placeholder: "Add note here" },
                            domProps: { value: _vm.newNote.remarks },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.newNote,
                                    "remarks",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  return _vm.$v.newNote.remarks.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.newNote && !_vm.$v.newNote.remarks.required
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v("Note is required."),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "field pb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "control is-flex is-justify-content-right",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button is-small is-primary tooltip is-tooltip",
                                attrs: { "data-tooltip": "Save new note" },
                                on: {
                                  click: function ($event) {
                                    return _vm.save()
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-pencil mdi-18px",
                                  }),
                                ]),
                                _c("span", [_vm._v("Save Note")]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-align-items-center pb-0 pt-3 has-text-primary",
                  },
                  [
                    _c("span", { staticClass: "icon is-small" }, [
                      _c("i", {
                        staticClass: "mdi mdi-note-text-outline mdi-20px",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _c("span", { staticClass: "pl-1" }, [_vm._v("Notes")]),
                  ]
                ),
                _c("div", {
                  staticClass: "is-divider mt-2 mb-3",
                  staticStyle: { width: "100%" },
                }),
                _vm.entitySummaries && _vm.entitySummaries.length === 0
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "container",
                    class: `has-background-${_vm.$theme.name}`,
                  },
                  _vm._l(_vm.entitySummaries, function (note, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "is-flex px-3 py-2" },
                      [
                        _c(
                          "transition",
                          {
                            attrs: {
                              mode: "out-in",
                              name: "custom-classes-transition",
                              "enter-active-class": `animate__animated animate__slideInRight animate_fastest`,
                              "leave-active-class": `animate__animated animate__slideInRight animate_fastest`,
                            },
                          },
                          [
                            _c(
                              "article",
                              { staticClass: "message is-flex is-info" },
                              [
                                _c(
                                  "div",
                                  {
                                    key: note.remarkId,
                                    staticClass:
                                      "message-body py-1 px-2 message-list",
                                  },
                                  [
                                    _c("span", {}, [
                                      _vm._v(_vm._s(note.remarks)),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex is-align-items-center is-size-7",
                                      },
                                      [
                                        note.firstName || note.displayName
                                          ? _c("user-profile-icon", {
                                              staticClass: "pr-1",
                                              attrs: {
                                                "is-text-profile": true,
                                                "first-name": note.firstName,
                                                "last-name": note.lastName,
                                                "display-name":
                                                  note.displayName,
                                                width: 20,
                                                height: 20,
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "is-italic" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$filters.formatDateTimeLocale(
                                                  note.remarkDateTime,
                                                  _vm.$userInfo.locale
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            style: `width: 100%; display: flex; justify-content: space-between;`,
          },
          [
            _c(
              "div",
              { staticStyle: { width: "100%" }, attrs: { align: "right" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary tooltip",
                    attrs: { "data-tooltip": "Close" },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
                    ]),
                    _c("span", [_vm._v("Close")]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }